/*
 *
 * SlackVerify constants
 *
 */

const prefix = 'ui/containers/SlackVerify';

export const VERIFY_SLACK_START = `${prefix}/VERIFY_SLACK_START`;
export const VERIFY_SLACK_SUCCESS = `${prefix}/VERIFY_SLACK_SUCCESS`;
export const VERIFY_SLACK_ERROR = `${prefix}/VERIFY_SLACK_ERROR`;
